import React, { Component } from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import Title from '../title/title';
import AsyncApp from '../../containers/AsyncApp';

class News extends Component {

  render() {
    var titleContent = <p>Technology is ever changing, and for individuals and businesses, it is rapidly becoming much more (inter)net-centric. See our news feeds below to catch up with what is happening right now in the world of technology and also in the UK (Powered by Reddit):</p>;
    return (
      <div class="site-container" id="portfolio">
        <ReactCSSTransitionGroup
          transitionAppear={true}
          transitionAppearTimeout={600}
          transitionEnterTimeout={600}
          transitionLeaveTimeout={200}
          transitionName={'SlideUp'}
        >
          <Title className="text-center" name="News" content={titleContent} />
          <div className="site-inner">
            <AsyncApp />
          </div>
        </ReactCSSTransitionGroup>
      </div>
    );
  }
}

export default News;


// WEBPACK FOOTER //
// ./src/components/news/news.js